import React, { useEffect, useState, useRef } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { cn } from '../../lib/utils';
export interface RowAction {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  danger?: boolean;
  disabled?: boolean;
}
interface RowActionsMenuProps {
  actions: RowAction[];
  ariaLabel?: string;
}
export function RowActionsMenu({
  actions,
  ariaLabel = 'Row actions'
}: RowActionsMenuProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const escHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', escHandler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', escHandler);
    };
  }, [open]);
  return <div className="relative inline-block" ref={ref} data-id="element-246">
      <button type="button" aria-label={ariaLabel} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(v => !v)} className="h-8 w-8 inline-flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500" data-id="element-247">
        <MoreHorizontal className="w-4 h-4" data-id="element-248" />
      </button>
      {open && <div role="menu" className="absolute right-0 z-20 mt-1 w-56 origin-top-right rounded-lg border border-slate-200 bg-white shadow-lg py-1 animate-in fade-in zoom-in-95 duration-100" data-id="element-249">
          {actions.map((action, i) => <button key={i} role="menuitem" type="button" disabled={action.disabled} onClick={() => {
        if (action.disabled) return;
        setOpen(false);
        action.onClick();
      }} className={cn('w-full flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors', action.disabled ? 'text-slate-300 cursor-not-allowed' : action.danger ? 'text-rose-600 hover:bg-rose-50' : 'text-slate-700 hover:bg-slate-50')} data-id="element-250">
              {action.icon && <span className="shrink-0 w-4 h-4 inline-flex" data-id="element-251">
                  {action.icon}
                </span>}
              <span data-id="element-252">{action.label}</span>
            </button>)}
        </div>}
    </div>;
}